export default class OfficeExpenseUnitEntry {
    id: number;
    description?: string;
    amount?: string;
    type?: string;
}



// WEBPACK FOOTER //
// ./src/models/AP/OfficeExpenseUnit.ts